import { render, staticRenderFns } from "./createFollow.vue?vue&type=template&id=701c5d57&scoped=true&"
import script from "./createFollow.vue?vue&type=script&lang=js&"
export * from "./createFollow.vue?vue&type=script&lang=js&"
import style0 from "./createFollow.vue?vue&type=style&index=0&id=701c5d57&prod&scoped=true&lang=scss&"
import style1 from "./createFollow.vue?vue&type=style&index=1&id=701c5d57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c5d57",
  null
  
)

export default component.exports